module.exports = __webpack_public_path__ + "static/media/Liri Spotify.bf9e9759.PNG";